module.exports = __webpack_public_path__ + "static/paintings-recent-works-thumbnail-5d9f9ce3bb178bec4404980074168e86.jpg";